/**
 * BottomNavigation - 移动端底部导航栏
 */
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAuth } from '../../contexts/AuthContext';
import { Home, Plus, User, Globe } from 'lucide-react';

const navItems = [
  { path: '/', label: '首页', icon: Home },
  { path: '/public', label: '公开社区', icon: Globe },
];

export default function BottomNavigation() {
  const location = useLocation();
  const navigate = useNavigate();
  const { isAuthenticated, user } = useAuth();
  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-lg border-t border-slate-200/60 safe-area-pb">
      <div className="flex items-center justify-around h-16 px-2">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center justify-center gap-1 w-16 h-14 rounded-xl transition-all ${
                active
                  ? 'bg-indigo-600 text-white'
                  : 'text-slate-500 hover:text-slate-700 hover:bg-slate-100'
              }`}
            >
              <motion.div
                whileTap={{ scale: 0.9 }}
                className="relative"
              >
                <Icon className="w-6 h-6" strokeWidth={active ? 2.5 : 2} />
              </motion.div>
              <span className={`text-xs ${active ? 'font-semibold' : 'font-medium'}`}>
                {item.label}
              </span>
            </Link>
          );
        })}

        {/* 创作按钮 - 凸起样式 */}
        <Link
          to="/create"
          className="flex flex-col items-center justify-center -mt-6"
        >
          <motion.div
            whileTap={{ scale: 0.9 }}
            className="w-14 h-14 rounded-full bg-gradient-to-r from-indigo-600 to-violet-600 text-white shadow-lg shadow-indigo-500/30 flex items-center justify-center"
          >
            <Plus className="w-7 h-7" />
          </motion.div>
          <span className="text-xs font-medium text-slate-600 mt-1">创作</span>
        </Link>

        {/* 我的 Tab */}
        <button
          onClick={() => navigate(isAuthenticated ? '/profile' : '/login')}
          className={`flex flex-col items-center justify-center gap-1 w-16 h-14 rounded-xl transition-all ${
            isActive('/profile')
              ? 'bg-indigo-600 text-white'
              : 'text-slate-500 hover:text-slate-700 hover:bg-slate-100'
          }`}
        >
          <motion.div
            whileTap={{ scale: 0.9 }}
            className="relative"
          >
            {isAuthenticated ? (
              <div className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-medium ${isActive('/profile') ? 'bg-white text-indigo-600' : 'bg-indigo-500 text-white'}`}>
                {user?.nickname?.[0]?.toUpperCase() || 'U'}
              </div>
            ) : (
              <User className="w-6 h-6" strokeWidth={isActive('/profile') ? 2.5 : 2} />
            )}
          </motion.div>
          <span className={`text-xs ${isActive('/profile') ? 'font-semibold' : 'font-medium'}`}>
            我的
          </span>
        </button>
      </div>
    </nav>
  );
}
